import { FC } from 'react'
import { FeedGuard } from 'components/features/socialFeed/FeedGuard/FeedGuard'
import { FeedPostsPageInner } from 'components/features/socialFeed/FeedPostsPage/FeedPostsPageInner'
import { PageMeta } from 'components/features/pfm/PageMeta/PageMeta'

type FeedPostsPageProps = {

}

export const FeedPostsPage: FC<FeedPostsPageProps> = () => {
  return (
    <FeedGuard>
      <PageMeta
        title='Peer Advice Feed'
        description='See what members are talking about right now'
      />
      <FeedPostsPageInner />
    </FeedGuard>
  )
}
